"use client";
import Link from "@casino/client/components/Link";
import useClientTranslations from "@casino/client/hooks/useClientTranslations";
import useCurrencyConfig from "@casino/legacy/client/hooks/currency/useCurrencyConfig";
import useWalletCurrency from "@casino/legacy/client/hooks/currency/useWalletCurrency";
import Button from "@casino/legacyUi/Button";
import {
  GAME_CARD_HOVER_TRANSLATION_KEYS,
  type GameCardTranslations,
} from "@casino/shared/components/GameCard/translations";
import DepositToPlayButton from "./DepositToPlayButton";

type Props = {
  gameHref: string;
  translations?: GameCardTranslations;
};

const DepositToPlay: FC<Props> = ({
  gameHref,
  translations: initialTranslations,
}) => {
  const walletCurrency = useWalletCurrency();
  const config = useCurrencyConfig();
  const type = config.type ?? "crypto";
  const translations = useClientTranslations(
    GAME_CARD_HOVER_TRANSLATION_KEYS,
    initialTranslations,
  );

  return (
    <div className="absolute inset-0 z-3 grid content-center items-center justify-center gap-2 px-3 bg-black/60 opacity-0 transition-opacity hover:opacity-100">
      <DepositToPlayButton type={type} name={walletCurrency as CashierCurrency}>
        <span className="text-xs">
          {translations?.["general.deposit_to_play"]}
        </span>
      </DepositToPlayButton>
      <Link href={gameHref} prefetch={false}>
        <Button variant="ghost" fullWidth size="xs">
          <p className="text-xs text-white">
            {translations?.["general.open_the_game"]}
          </p>
        </Button>
      </Link>
    </div>
  );
};

export default DepositToPlay;
